import { FileSourceEnum } from '@systemeio/file-manager'
import { advancedTextEditorExtensions, TipTapEditor, TipTapEditorProps } from '@systemeio/tip-tap'
import { STORE_TOOLBAR_ID } from 'pages/stores/[storeId]'
import { FC } from 'react'
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description'
import { FieldLabel } from 'shared/components/form/field-label'
import useMediaQuery from 'shared/hooks/use-media-query'
import { getSSRDocument } from 'shared/utils/get-ssr-document'

type Props = {
  label?: string
  required?: boolean
  content: string
  error?: string
  statusIcon?: React.ReactNode
} & TipTapEditorProps

export const StoreTextEditor: FC<Props> = ({
  label,
  required,
  content,
  error,
  statusIcon,
  ...rest
}) => {
  const storeToolbarHeight = getSSRDocument()?.getElementById(STORE_TOOLBAR_ID)?.clientHeight ?? 0
  const { isLG } = useMediaQuery()
  const toolbarStyles = {
    top: isLG ? '0' : `${storeToolbarHeight}px`,
  }

  return (
    <div className="flex flex-col gap-1">
      <FieldLabel label={label} required={required} />
      <div className={'relative'}>
        {statusIcon && (
          <div className="absolute right-2 top-16 z-20 rounded-lg bg-white p-2 shadow-lg">
            {statusIcon}
          </div>
        )}
        <TipTapEditor
          extensions={advancedTextEditorExtensions}
          content={content}
          toolbarStyles={toolbarStyles}
          fileSource={FileSourceEnum.DigitalStore}
          {...rest}
        />
      </div>
      <FieldErrorAndDescription error={error} />
    </div>
  )
}
